export default __webpack_public_path__ + "static/media/avatar-8.f7e34bc6.jpg";